import ConfigEndpoints from "./ConfigEndpoints";
import LocationEndpoints from "./LocationEndpoints";
import IConfigEndpoints from "./framework/IConfigEndpoints";
import ILocationEndpoints from "./framework/ILocationEndpoints";
import IAppConfig from "models/IAppConfig";
import { IEndpointProps } from "apiConsumers/EndpointsBaseClass";
import EmailSubscriptionEndpoints from "./EmailSubscriptionEndpoints";
import IEmailSubscriptionEndpoints from "./framework/IEmailSubscriptionEndpoints";
import EmailSubscriptionListType from "models/EmailSubscriptionListType";
import CountryCode from "models/CountryCode";

interface IProps extends IEndpointProps {}

export default class BackendApiConsumer {
    private configEndpoints: IConfigEndpoints;
    private emailSubscriptionEndpoints: IEmailSubscriptionEndpoints;
    private locationEndpoints: ILocationEndpoints;

    constructor(props: IProps) {
        this.configEndpoints = new ConfigEndpoints(props);
        this.locationEndpoints = new LocationEndpoints(props);
        this.emailSubscriptionEndpoints = new EmailSubscriptionEndpoints(props);
    }

    public async getConfig(): Promise<IAppConfig> {
        return await this.configEndpoints.getConfig();
    }

    public async getIsoLocation(): Promise<CountryCode> {
        return await this.locationEndpoints.getIsoLocation();
    }

    public async subscribeEmail(
        email: string,
        list: EmailSubscriptionListType,
        termsLabel?: string
    ): Promise<any> {
        return await this.emailSubscriptionEndpoints.postEmail(email, list, termsLabel);
    }
}
